"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = void 0;
var react_1 = require("react");
var defaultOptions = { isActive: true };
/**
 * useOnClickOutside detects a click outside of a given element.
 * @param ref React ref of an element you want to track the clicks around.
 * @param handler Function to call on click outside.
 * @param options
 *
 * @see https://usehooks.com/useOnClickOutside/
 */
var useOnClickOutside = function (ref, handler, options) {
    if (options === void 0) { options = defaultOptions; }
    (0, react_1.useEffect)(function () {
        if (!ref || !options.isActive) {
            return;
        }
        var listener = function (event) {
            var target = event.target;
            if (!ref.current || ref.current.contains(target)) {
                return;
            }
            handler === null || handler === void 0 ? void 0 : handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler, options.isActive]);
};
exports.useOnClickOutside = useOnClickOutside;
//# sourceMappingURL=use-on-click-outside.js.map